import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/transportList/list',
    method: 'post',
    data,
  })
}
export async function getDetail(data) {
  return request({
    url: '/transportList/detail',
    method: 'get',
    params: data,
  })
}
// 撤销审核(历史查询页面)
export async function revokeForHis(data) {
  return request({
    url: '/transportList/revokeForHis',
    method: 'post',
    data,
  })
}
// 撤销审核(企业查询页面)
export async function revokeForAllHis(data) {
  return request({
    url: '/transportList/revoke',
    method: 'post',
    data,
  })
}